import React from 'react'
import { Route, IndexRoute } from 'react-router'

import About    from './about'
import Home     from './game/index'
import GameShow from './game/show'
import NotFound from './notfound'

export default (
  <Route path="/" name="home">
    <IndexRoute component={ Home } />
    <Route path="/about" component={ About } />
    <Route path="/game/:game" component={ GameShow } />
    <Route path="*" component={ NotFound } />
  </Route>
)



/** WEBPACK FOOTER **
 ** ./web/static/app/components/routes.jsx
 **/